import { userIsInternal } from '../../util/user-is-internal';

export const mergeAuthConfigs = (authConfig1, authConfig2) => {
	return {
		...authConfig1,
		...authConfig2,
		external: {
			...(authConfig1.external || {}),
			...(authConfig2.external || {})
		},
		internal: {
			...(authConfig1.internal || {}),
			...(authConfig2.internal || {})
		}
	};
};

export const sanitiseAuthStrategiesConfig = (config, authConfig) => {
	return {
		...mergeAuthConfigs(config, authConfig),
		...{ isAuthRequired: config.isAuthRequired ?? false },
		...(userIsInternal() ? config.internal : config.external),
	};
};
